import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Pork Chop',
  source: 'https://www.seriouseats.com/perfect-pan-seared-pork-chop-recipe',
  totalTime: time(24, 15),
  servings: 2,
  tags: { type: 'main' },
  options: [
    {
      key: 'doneness',
      default: 'medium-rare',
      choices: [
        {
          key: 'medium-rare',
          label: 'Medium-rare ({!130F})',
          steps: {
            roast: { addTime: time(0, 30), text: '~{time} until internal {!115F}' },
            sear: { text: '{!130F}' },
          },
        },
        {
          key: 'medium',
          label: 'Medium ({!140F})',
          steps: {
            roast: { addTime: time(0, 35), text: '~{time} until internal {!125F}' },
            sear: { text: '{!140F}' },
          },
        },
      ],
    },
  ],
  ingredients: [
    { name: 'pork chops', quantity: '2',
      note: '1.5-in thick',
    },
    { name: 'sugar', quantity: '1 1/2', unit: 'tsp' },
    { name: 'kosher salt', quantity: '2', unit: 'tbsp' },
    { name: 'black pepper' },
    { name: 'butter', quantity: '4', unit: 'tbsp' },
    { name: 'shallot', quantity: '1',
      note: 'thinly sliced',
    },
    { name: "garlic", quantity: '4', unit: "cloves", customUnit: true,
      note: 'smashed',
    },
    { name: 'fresh thyme', quantity: '8', unit: 'sprigs', customUnit: true },
  ],
  directions: [
    {
      title: 'Dry brine',
      bullets: [
        "Pat {pork chops} dry with paper towel",
        "Season generously with {sugar}, {kosher salt} & {black pepper}",
        "Refrigerate on wire rack, uncovered, 8–24h",
      ],
    },
    {
      title: 'Roast',
      bullets: [
        "Preheat oven to {!250F}",
        "Place wire rack on baking sheet in oven",
        "Cook {opt:doneness:roast}"
      ],
    },
    {
      title: 'Sear',
      bullets: [
        "In large skillet, heat {butter:half} over medium-high until just smoking",
        "Place pork in skillet & cook 1 min per side (2 min total), until starting to brown",
        "Add {butter:half}, {shallot}, {garlic} & {fresh thyme} to skillet",
        "Continue cooking 1 min per side (2 min total), spooning shallots & thyme on top of chops & basting with butter, until golden brown & well-crusted",
        "Sear edges of chops until crisp, ~30 sec per side (1 min total)",
        "Final internal temp should be {opt:doneness:sear}",
      ],
    },
  ],
};

export default recipe;
